module.exports = __webpack_public_path__ + "images/花筑般蓝pr长图06-2.jpg?v=aa8c3451";


/*****************
 ** WEBPACK FOOTER
 ** ./src/images/home/quanjing/huazhu3/花筑般蓝pr长图06-2.jpg
 ** module id = 52
 ** module chunks = 1 2
 **/